<template>
  <el-dialog v-bind="{ ...$attrs, ...$props}" :class="customClassWithBorder">
    <template #header>
      <div class="tq-dialog-title" v-if="!$slots.header">
        <span>{{ $attrs.header || $attrs.title }}</span>
      </div>
      <slot name="header" v-else></slot>
    </template>
    <template #default>
      <slot></slot>
    </template>
    <template #footer v-if="!noFooter">
      <div class="tq-dialog-footer" v-if="!$slots.footer && (!(hiddenConfirm && hiddenCancel))">
        <el-button v-if="!hiddenCancel" :disabled="disableCancel" :loading="loadingCancel" @click="cancelModal">{{cancelText}}</el-button>
        <el-button v-if="!hiddenConfirm" :disabled="disableConfirm" :loading="loadingConfirm"  type="primary" @click="confirmModal">{{confirmText}}</el-button>
      </div>
      <slot name="footer" v-else></slot>
    </template>
  </el-dialog>
</template>

<script lang="ts">
export default {
  name: "TqDialog",
  data() {
    return {

    }
  },
  props: {
    cancelText: {
      type: String,
      default: '取消'
    },
    visible: {
      type: Boolean,
      default: false
    },
    noFooter: {
      type: Boolean,
      default: false
    },
    hiddenConfirm: {
      type: Boolean,
      default: false
    },
    hiddenCancel: {
      type: Boolean,
      default: false
    },
    disableConfirm: {
      type: Boolean,
      default: false
    },
    disableCancel: {
      type: Boolean,
      default: false
    },
    loadingConfirm: {
      type: Boolean,
      default: false
    },
    loadingCancel: {
      type: Boolean,
      default: false
    },
    hiddenHeaderBorder: {
      type: Boolean,
      default: false
    },
    hiddenFooterBorder: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: '确认'
    },
    customClass: {
      type: String,
      default: 'tq-dialog-wrapper'
    },
  },
  computed: {
    customClassWithBorder() {
      if (this.hiddenHeaderBorder && this.hiddenFooterBorder) {
        return this.customClass + ' no-header-border no-footer-border'
      }else if (this.hiddenHeaderBorder) {
        return this.customClass + ' no-header-border'
      }else if (this.hiddenFooterBorder) {
        return this.customClass + ' no-footer-border'
      }
      return this.customClass
    }
  },
  methods: {
    cancelModal() {
      this.$emit('cancelModal')
    },
    confirmModal() {
      this.$emit('confirmModal')
    }
  }
}
</script>